import { adminHttpClient } from '../../../commons/adminHttpClient'

const initiatePerksBenefitRenewalEndpoint = (startDate: string): Promise<void> =>
  adminHttpClient.post('Benefit/BenefitRenewal/Perks/InitiateRenewal', { startDate })

export default initiatePerksBenefitRenewalEndpoint
